import React, { createContext, useState, useMemo } from "react";

export const ActivityContext = createContext();

export const ActivityProvider = ({ children }) => {
  const [events, setEvents] = useState([])
  const [ongoingEvents, setOngoingEvents] = useState([])
  const [externalEvents, setExternalEvents] = useState([])
  const [daysAhead, setDaysAhead] = useState(90)

  const value = useMemo( () => (
    {
      events,
      setEvents,
      ongoingEvents,
      setOngoingEvents,
      externalEvents,
      setExternalEvents,
      daysAhead,
      setDaysAhead
    }
  ), [
    events,
    setEvents,
    ongoingEvents,
    setOngoingEvents,
    externalEvents,
    setExternalEvents,
    daysAhead,
    setDaysAhead
  ])

  return (
    <ActivityContext.Provider
      value={value}
    >
      {children}
    </ActivityContext.Provider>
  );
}
